import { TranslateService } from "./../../shared/translate/translate.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { InvoiceService } from "../../invoice/models/invoice.service";
import { LegacyInvoiceService } from "../../invoice/models/legacy-invoice.service";
import { AuthService } from "../../shared/models/auth.service";

@Component({
  selector: "wego-admin",
  template: `
  <div class="admin-role">
    <div [class]="toggleClass" (window:resize)="onResize($event)" >
      <wego-navbar (toggleMenu)="ToggleMenuLocal()"></wego-navbar>
      <wego-sidebar [menu]="menu"></wego-sidebar>
      <wego-content-wrapper></wego-content-wrapper>
      <wego-popup-lodder [isLoading]="isLoading"></wego-popup-lodder>
      <wego-footer></wego-footer>
    </div>
  </div>
  `
  // [IsLoading]="isLoading"
})
export class AdminComponent implements OnInit, OnDestroy {
  toggleClass: string = "ui-skins sidebar-mini";
  menu: any = [];
  isLoading: boolean;
  errorMessage: string;

  constructor(
    private translate: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.translate.setDetectedLang();
    this.authService.GetBackOfficeMenu().subscribe(
      res => {
        this.menu = res.data;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ToggleMenuLocal() {
    if (window.innerWidth > 767) {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
      else if (
        this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" ||
        this.toggleClass == "ui-skins sidebar-mini sidebar-open"
      )
        this.toggleClass = "ui-skins sidebar-mini";
    } else {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-open";
      else if (
        this.toggleClass == "ui-skins sidebar-mini sidebar-open" ||
        this.toggleClass == "ui-skins sidebar-mini sidebar-collapse"
      )
        this.toggleClass = "ui-skins sidebar-mini";
    }
  }

  onResize(event: any) {}

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role/components/admin.component.ts